import React, { useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { useDispatch } from 'react-redux';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';

import isLandscape from '../components/UI/utils/isLandscape';
import isMobileBrowser from '../components/UI/utils/isMobileBrowser';
import { GLOBALS } from '../store/actions/utils/actionCases';
import { isWeb } from '../src/platformUtils';

import Home from '../components/home/Home';
import Contact from '../components/Contact';
import Privacy from '../components/privacy/Privacy';
import Screens from '../screens/Screens';
import WebViewNavigator from './WebViewNavigator';
import { detectUrlParam } from '../src/urlUtils';

const Nav = createStackNavigator();

const linking = {
	prefixes: [
		'burncammedical.com',
		'https://burncammedical.com',
		'localhost:19006',
	],
	config: {
		screens: {
			[Screens.home]: '',
			[Screens.contact]: 'contact',
			[Screens.privacy]: 'privacy',
		}
	}
};

const AppNavigator = () => {

	const dispatch = useDispatch();

	// Set global dimensions
	const isLandScapeLocal = isLandscape();
	const isMobileBrowserLocal = isWeb ? isMobileBrowser() : false;

	const isWebView = isWeb ? detectUrlParam('isWebView') !== '' : false;

	useEffect(() => {
		dispatch({
			type: GLOBALS.IS_LANDSCAPE,
			bool: isLandScapeLocal,
		});
	}, [dispatch, isLandScapeLocal]);

	useEffect(() => {
		dispatch({
			type: GLOBALS.IS_MOBILE_BROWSER,
			bool: isMobileBrowserLocal,
		});
	}, [dispatch, isMobileBrowserLocal]);

	return (
		<NavigationContainer linking={linking}>
			{!isWebView && <Nav.Navigator screenOptions={{
				headerStyle: {
					backgroundColor: COLORS.primary,
					height: 50,
				},
				headerTitleStyle: {
					fontFamily: FONTS.bold
				},
				headerBackTitleStyle: {
					fontFamily: FONTS.bold
				},
				headerTintColor: COLORS.white,
				activeTintColor: COLORS.primary,
			}}>
				<Nav.Screen
					name={Screens.home}
					component={Home}
				/>
				<Nav.Screen
					name={Screens.contact}
					component={Contact}
				/>
				<Nav.Screen
					name={Screens.privacy}
					component={Privacy}
				/>
			</Nav.Navigator>}
			{isWeb && isWebView && <WebViewNavigator/>}
		</NavigationContainer>
	);
};

export const navStyles = StyleSheet.create({
	transitionContainer: {
		height: '10vh',
		width: '100%',
		backgroundColor: COLORS.light
	},
	logo: {
		height: 40,
		width: 20,
		marginVertical: 5,
		marginLeft: 15,
		justifyContent: 'center',
		alignItems: 'center',
	},
	navButtonsContainer: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center',
	},
	navButtonContainer: {
		backgroundColor: COLORS.white,
		borderRadius: 15,
		width: 90,
		height: 30,
		marginVertical: 5,
		marginHorizontal: 10,
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'row',
	},
	navButtonText: {
		marginHorizontal: 5,
		fontFamily: FONTS.default,
		fontSize: FONT_SIZES.md,
	}
});

export default AppNavigator;
